class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems =
        this.closest('cart-drawer-items') || this.closest('cart-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);
    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
    );
  }

  getSectionsToRender() {
    return [
      ...Cart.getLiveRegions(),
      {
        id: '#CartPage-Head',
        section: this.dataset.sectionId,
        selector: `#shopify-section-${this.dataset.sectionId} #CartPage-Head`,
      },
      {
        id: '#CartPage-Body',
        section: this.dataset.sectionId,
        selector: `#shopify-section-${this.dataset.sectionId} #CartPage-Body`,
      },
    ];
  }

  updateQuantity(line, quantity) {
    const sectionsToRender = this.getSectionsToRender().map(
      (section) => section.section,
    );
    const uniqSections = Array.from(new Set(sectionsToRender));

    const body = JSON.stringify({
      line,
      quantity,
      sections: uniqSections,
      sections_url: window.location.pathname,
    });

    this.toggleLoading(true);

    Cart.update(body)
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace = document.querySelector(section.id);

          if (!elementToReplace) return;

          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });
        this.reFetchRecommendations();
        this.fetchUpsells(parsedState.sections[this.dataset.sectionId]);
        this.updateLiveRegions(parsedState);
      })
      .catch((error) => {
        console.error(error);
        const quantityInputs = document.querySelectorAll(
          `[id*="ProductQuantity-${line}"]`,
        );

        if (quantityInputs.length) {
          quantityInputs.forEach((input) => {
            input.value = input.getAttribute('value');
          });
        }
      })
      .finally(() => {
        this.toggleLoading();
      });
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  renderContents(response) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.querySelector(section.id);

      if (!sectionElement) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(
        response.sections[section.section],
        section.selector,
      );
    });
    this.reFetchRecommendations();
    this.fetchUpsells(response.sections[this.dataset.sectionId]);
  }

  updateLiveRegions(parsedState) {}

  reFetchRecommendations() {
    document.querySelectorAll('widget-drawer').forEach((drawer) => {
      drawer.fetchRecommendations();
    });
    document.querySelector('widget-cross-sell')?.fetchContents();
  }

  toggleLoading(flag) {
    this.classList.toggle('is-loading', flag);
  }

  fetchUpsells(html) {
    const widget = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('#Widget-Cross-Sells');

    if (!widget) {
      return;
    }

    const widgetItems = widget.querySelector('[data-items]');

    document.querySelector('#Widget-Cross-Sells [data-items]').innerHTML =
      widgetItems.innerHTML;
  }
}

customElements.define('cart-items', CartItems);
